export default __webpack_public_path__ + "static/media/dandelions-compass.6d58935a.png";